"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateMapWithControl = exports.updateMapWithProcess = exports.remove = exports.getControlIds = exports.create = exports.findNumberToCreate = exports.update = exports.getContainCycle = exports.updateMaps = exports.getAll = exports.get = void 0;
/* eslint-disable newline-per-chained-call */
var PRC_1 = require("@cck/common/dist/data/PRC");
var lodash_1 = __importDefault(require("lodash"));
var firebase = __importStar(require("../firebase/fbase"));
var Admin = __importStar(require("../utils/Admin"));
var UpdateContainer_1 = __importStar(require("../utils/UpdateContainer"));
var ControlManager = __importStar(require("./ControlManager"));
var CycleManager = __importStar(require("./CycleManager"));
var ProcessManager = __importStar(require("./ProcessManager"));
var RCMUtils_1 = require("./RCMUtils");
var get = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, firebase.dbService.collection(RCMUtils_1.RISK_COLLECTION_NAME).doc(id).get()];
            case 1: return [2 /*return*/, (_a.sent()).data()];
        }
    });
}); };
exports.get = get;
var getAll = function () { return __awaiter(void 0, void 0, void 0, function () {
    var collectionData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, firebase.dbService.collection(RCMUtils_1.RISK_COLLECTION_NAME).get()];
            case 1:
                collectionData = _a.sent();
                return [2 /*return*/, lodash_1.default.map(collectionData.docs, function (docData) { return docData.data(); })];
        }
    });
}); };
exports.getAll = getAll;
var updateMap = function (riskId, updateIds) { return __awaiter(void 0, void 0, void 0, function () {
    var finalUpdateObject, riskObject;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                finalUpdateObject = {};
                return [4 /*yield*/, (0, exports.get)(riskId)];
            case 1:
                riskObject = _a.sent();
                lodash_1.default.forEach(['cycleIds', 'processIds', 'controlIds'], function (targetKey) {
                    var newIds = (0, UpdateContainer_1.applyUpdateIds)(riskObject[targetKey], updateIds === null || updateIds === void 0 ? void 0 : updateIds[targetKey]);
                    lodash_1.default.set(finalUpdateObject, targetKey, newIds);
                });
                return [4 /*yield*/, firebase.dbService.collection(RCMUtils_1.RISK_COLLECTION_NAME).doc(riskId).update(finalUpdateObject)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
var updateMaps = function (updateObject) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.all(lodash_1.default.map(updateObject.values(), function (updateIds, riskId) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, updateMap(riskId, updateIds)];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); }))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.updateMaps = updateMaps;
var getContainCycle = function (controls) { return __awaiter(void 0, void 0, void 0, function () {
    var cycleDataAll, riskDataAll, user;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, CycleManager.getAll()];
            case 1:
                cycleDataAll = _a.sent();
                return [4 /*yield*/, (0, exports.getAll)()];
            case 2:
                riskDataAll = _a.sent();
                return [4 /*yield*/, Admin.getOrCreateUser()];
            case 3:
                user = _a.sent();
                return [2 /*return*/, (0, lodash_1.default)(riskDataAll)
                        .map(function (riskObject) {
                        var _a;
                        var cycleId = (_a = riskObject.cycleIds) === null || _a === void 0 ? void 0 : _a[0];
                        var relateCycleObject = lodash_1.default.find(cycleDataAll, { id: cycleId });
                        if (!relateCycleObject) {
                            return undefined;
                        }
                        var controlIds = riskObject.controlIds;
                        if ((user.level === 'UPLOADER' || user.level === 'NORMAL') &&
                            !lodash_1.default.some(controlIds, function (controlId) { return lodash_1.default.find(controls, { id: controlId }); })) {
                            return undefined;
                        }
                        riskObject.type = PRC_1.PRCType.risk;
                        riskObject.cycleNumber = relateCycleObject.cycleNumber;
                        riskObject.cycleName = relateCycleObject.cycleName;
                        riskObject.categoryNumber = relateCycleObject.categoryNumber;
                        riskObject.categoryName = relateCycleObject.categoryName;
                        riskObject.subCategoryNumber = relateCycleObject.subCategoryNumber;
                        riskObject.subCategoryName = relateCycleObject.subCategoryName;
                        return riskObject;
                    })
                        .compact()
                        .value()];
        }
    });
}); };
exports.getContainCycle = getContainCycle;
var update = function (risk) { return __awaiter(void 0, void 0, void 0, function () {
    var riskId, docRef, riskData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                riskId = risk.id;
                docRef = firebase.dbService.collection(RCMUtils_1.RISK_COLLECTION_NAME).doc(riskId);
                return [4 /*yield*/, docRef.update({
                        name: risk.name,
                        inherentRiskLevel: risk.inherentRiskLevel
                    })
                    // RISK 가 업데이트 되면 연결된 CONTROL 에서도 바뀌어야 한다.(riskName)
                    // 그리고 설계평가 보고서 Template 에서도 바뀌어야 한다(riskName)
                ];
            case 1:
                _a.sent();
                return [4 /*yield*/, (0, exports.get)(riskId)];
            case 2:
                riskData = _a.sent();
                return [4 /*yield*/, Promise.all(lodash_1.default.map(riskData.controlIds, function (controlId) { return __awaiter(void 0, void 0, void 0, function () {
                        var controlData;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, ControlManager.get(controlId)];
                                case 1:
                                    controlData = _a.sent();
                                    controlData.riskName = risk.name;
                                    // CONTROL 업데이트
                                    return [4 /*yield*/, firebase.dbService.collection('CONTROL').doc(controlId).update({
                                            riskName: risk.name,
                                            riskInherentRiskLevel: risk.inherentRiskLevel
                                        })];
                                case 2:
                                    // CONTROL 업데이트
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); }))];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.update = update;
var findNumberToCreate = function (processId) { return __awaiter(void 0, void 0, void 0, function () {
    var riskDataAll;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, exports.getAll)()];
            case 1:
                riskDataAll = _a.sent();
                return [2 /*return*/, 'R' + (0, RCMUtils_1.getNewNumber)(processId, riskDataAll)];
        }
    });
}); };
exports.findNumberToCreate = findNumberToCreate;
var makeUpdateMapFromCreate = function (riskId, cycleId, processId) { return __awaiter(void 0, void 0, void 0, function () {
    var cycleUpdateMap, processUpdateMap;
    return __generator(this, function (_a) {
        cycleUpdateMap = new UpdateContainer_1.default();
        cycleUpdateMap.add(cycleId, 'riskIds', riskId);
        processUpdateMap = new UpdateContainer_1.default();
        processUpdateMap.add(processId, 'riskIds', riskId);
        return [2 /*return*/, { cycleUpdateMap: cycleUpdateMap, processUpdateMap: processUpdateMap }];
    });
}); };
var create = function (riskId, risk) { return __awaiter(void 0, void 0, void 0, function () {
    var cycleId, processId, _a, cycleUpdateMap, processUpdateMap, docRef;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, (0, RCMUtils_1.isNotUniqueId)(riskId)];
            case 1:
                /*
                새로운 RISK 를 만든다.
              
                기존에 RISK 를 생성할 때 RISK 는 CYCLE 에 연결되어져서 만들어졌다.
                하지만 이제는 생성되는 RISK 는 PROCESS 에 귀속되기 때문에
                CYCLE-PROCESS 까지 연결되어져서 만들어진다.
              
                속하는 CYCLE 의 riskPathArray 에 RISK 를 추가한다.
                속하는 PROCESS 의 riskPathARray 에 RISK 를 추가한다
              
                @param: risk
                */
                if (_b.sent()) {
                    throw new Error("Not unique id ".concat(riskId));
                }
                if (lodash_1.default.isEmpty(risk.cycleIds) || lodash_1.default.isEmpty(risk.processIds)) {
                    throw new Error('Empty cycle id or process id');
                }
                cycleId = risk.cycleIds[0];
                processId = risk.processIds[0];
                return [4 /*yield*/, makeUpdateMapFromCreate(riskId, cycleId, processId)];
            case 2:
                _a = _b.sent(), cycleUpdateMap = _a.cycleUpdateMap, processUpdateMap = _a.processUpdateMap;
                docRef = firebase.dbService.collection(RCMUtils_1.RISK_COLLECTION_NAME).doc(riskId);
                return [4 /*yield*/, docRef.set({
                        id: riskId,
                        name: risk.name,
                        inherentRiskLevel: risk.inherentRiskLevel,
                        cycleIds: [cycleId],
                        processIds: [processId],
                        controlIds: []
                    })];
            case 3:
                _b.sent();
                return [4 /*yield*/, CycleManager.updateMaps(cycleUpdateMap)];
            case 4:
                _b.sent();
                return [4 /*yield*/, ProcessManager.updateMaps(processUpdateMap)];
            case 5:
                _b.sent();
                return [2 /*return*/, riskId];
        }
    });
}); };
exports.create = create;
var getControlIds = function (riskId) { return __awaiter(void 0, void 0, void 0, function () {
    var riskData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, exports.get)(riskId)];
            case 1:
                riskData = _a.sent();
                return [2 /*return*/, riskData.controlIds];
        }
    });
}); };
exports.getControlIds = getControlIds;
var makeUpdateMapFromDelete = function (riskId) { return __awaiter(void 0, void 0, void 0, function () {
    var riskData, cycleId, cycleUpdateMap, processUpdateMap, controlUpdateMap;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, exports.get)(riskId)];
            case 1:
                riskData = _a.sent();
                cycleId = riskData.cycleIds[0] // 연결된 cycle 은 무조건 한개다
                ;
                cycleUpdateMap = new UpdateContainer_1.default();
                cycleUpdateMap.del(cycleId, 'riskIds', riskId);
                processUpdateMap = new UpdateContainer_1.default();
                processUpdateMap.dels(riskData.processIds, 'riskIds', riskId);
                controlUpdateMap = new UpdateContainer_1.default();
                controlUpdateMap.dels(riskData.controlIds, 'riskIds', riskId);
                // RISK 에 연결된 CONTROL 들은 RISK 와 연결된 PROCESS 의 controlPatharray 에서도 지워야 한다.
                lodash_1.default.forEach(riskData.controlIds, function (controlId) {
                    processUpdateMap.dels(riskData.processIds, 'controlIds', controlId);
                });
                return [2 /*return*/, { cycleUpdateMap: cycleUpdateMap, processUpdateMap: processUpdateMap, controlUpdateMap: controlUpdateMap }];
        }
    });
}); };
var remove = function (riskId) { return __awaiter(void 0, void 0, void 0, function () {
    var controlIdList, updateResult, docRef;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, exports.getControlIds)(riskId)];
            case 1:
                controlIdList = _a.sent();
                if (controlIdList.length > 0) {
                    // 연결된 CONTROL 이 존재. 삭제 불가
                    return [2 /*return*/, Promise.reject(new Error("\uC0AD\uC81C \uBD88\uAC00. \uC5F0\uACB0\uB41C CONTROL \uC774 \uC874\uC7AC\uD569\uB2C8\uB2E4. ".concat(controlIdList)))];
                }
                return [4 /*yield*/, makeUpdateMapFromDelete(riskId)];
            case 2:
                updateResult = _a.sent();
                docRef = firebase.dbService.collection(RCMUtils_1.RISK_COLLECTION_NAME).doc(riskId);
                return [4 /*yield*/, docRef.delete()];
            case 3:
                _a.sent();
                return [4 /*yield*/, CycleManager.updateMaps(updateResult.cycleUpdateMap)];
            case 4:
                _a.sent();
                return [4 /*yield*/, ProcessManager.updateMaps(updateResult.processUpdateMap)];
            case 5:
                _a.sent();
                return [4 /*yield*/, ControlManager.updateMaps(updateResult.controlUpdateMap)];
            case 6:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.remove = remove;
var makeUpdateMapWithProcess = function (riskId, processIds) { return __awaiter(void 0, void 0, void 0, function () {
    var riskData, originalProcessIds, controlIds, addProcessIdList, delProcessIdList, controlUpdateMap, processUpdateMap;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, exports.get)(riskId)];
            case 1:
                riskData = _a.sent();
                originalProcessIds = riskData.processIds;
                controlIds = riskData.controlIds;
                addProcessIdList = lodash_1.default.difference(processIds, originalProcessIds);
                delProcessIdList = lodash_1.default.difference(originalProcessIds, processIds);
                controlUpdateMap = new UpdateContainer_1.default();
                processUpdateMap = new UpdateContainer_1.default();
                lodash_1.default.forEach(addProcessIdList, function (processId) {
                    lodash_1.default.forEach(controlIds, function (controlId) {
                        controlUpdateMap.add(controlId, 'processIds', processId);
                        processUpdateMap.add(processId, 'controlIds', controlId);
                    });
                    processUpdateMap.add(processId, 'riskIds', riskId);
                });
                // 제거될 PROCESS list
                delProcessIdList.forEach(function (processId) {
                    controlIds.forEach(function (controlId) {
                        controlUpdateMap.del(controlId, 'processIds', processId);
                        processUpdateMap.del(processId, 'controlIds', controlId);
                    });
                    processUpdateMap.del(processId, 'riskIds', riskId);
                });
                return [2 /*return*/, { processUpdateMap: processUpdateMap, controlUpdateMap: controlUpdateMap }];
        }
    });
}); };
var updateMapWithProcess = function (riskId, processIds) { return __awaiter(void 0, void 0, void 0, function () {
    var updateResult, docRef;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, makeUpdateMapWithProcess(riskId, processIds)];
            case 1:
                updateResult = _a.sent();
                docRef = firebase.dbService.collection(RCMUtils_1.RISK_COLLECTION_NAME).doc(riskId);
                return [4 /*yield*/, docRef.update({
                        processIds: processIds
                    })];
            case 2:
                _a.sent();
                return [4 /*yield*/, ProcessManager.updateMaps(updateResult.processUpdateMap)];
            case 3:
                _a.sent();
                return [4 /*yield*/, ControlManager.updateMaps(updateResult.controlUpdateMap)];
            case 4:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.updateMapWithProcess = updateMapWithProcess;
var makeUpdateMapWithControl = function (riskId, controlIds) { return __awaiter(void 0, void 0, void 0, function () {
    var riskData, originalControlIds, addControlIdList, delControlIdList, controlDataAll, processUpdateMap, riskUpdateMap, controlUpdateMap;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, exports.get)(riskId)];
            case 1:
                riskData = _a.sent();
                originalControlIds = riskData.controlIds;
                addControlIdList = lodash_1.default.difference(controlIds, originalControlIds);
                delControlIdList = lodash_1.default.difference(originalControlIds, controlIds);
                return [4 /*yield*/, ControlManager.getAll()];
            case 2:
                controlDataAll = _a.sent();
                processUpdateMap = new UpdateContainer_1.default();
                riskUpdateMap = new UpdateContainer_1.default();
                controlUpdateMap = new UpdateContainer_1.default();
                addControlIdList.forEach(function (controlId) {
                    var controlData = lodash_1.default.find(controlDataAll, {
                        id: controlId
                    });
                    // 연결되어 있던 RISK 가 있는지 체크
                    var prevRiskId = controlData === null || controlData === void 0 ? void 0 : controlData.riskNumber;
                    if (prevRiskId) {
                        controlUpdateMap.del(controlId, 'riskIds', prevRiskId);
                        riskUpdateMap.del(prevRiskId, 'controlIds', controlId);
                        processUpdateMap.dels(controlData === null || controlData === void 0 ? void 0 : controlData.processIds, 'controlIds', controlId);
                    }
                    controlUpdateMap.add(controlId, 'riskIds', riskId);
                    // 현재 연결될 RISK 는 필요없음. Main 에서 처리
                    // 새로 연결될 PROCESS
                    processUpdateMap.adds(riskData.processIds, 'controlIds', controlId);
                });
                // 제거될 CONTROL list
                delControlIdList.forEach(function (controlId) {
                    // 제거될 CONTROL
                    controlUpdateMap.del(controlId, 'riskIds', riskId);
                    // PROCESS
                    processUpdateMap.dels(riskData.processIds, 'controlIds', controlId);
                });
                return [2 /*return*/, { processUpdateMap: processUpdateMap, riskUpdateMap: riskUpdateMap, controlUpdateMap: controlUpdateMap }];
        }
    });
}); };
var updateMapWithControl = function (riskId, controlIds) { return __awaiter(void 0, void 0, void 0, function () {
    var updateResult, docRef;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, makeUpdateMapWithControl(riskId, controlIds)];
            case 1:
                updateResult = _a.sent();
                docRef = firebase.dbService.collection(RCMUtils_1.RISK_COLLECTION_NAME).doc(riskId);
                return [4 /*yield*/, docRef.update({ controlIds: controlIds })];
            case 2:
                _a.sent();
                return [4 /*yield*/, ProcessManager.updateMaps(updateResult.processUpdateMap)];
            case 3:
                _a.sent();
                return [4 /*yield*/, (0, exports.updateMaps)(updateResult.riskUpdateMap)];
            case 4:
                _a.sent();
                return [4 /*yield*/, ControlManager.updateMaps(updateResult.controlUpdateMap)];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
exports.updateMapWithControl = updateMapWithControl;
//# sourceMappingURL=RiskManager.js.map